import { render, staticRenderFns } from "./IncompatipleIcon.vue?vue&type=template&id=5d0ae878&scoped=true"
import script from "./IncompatipleIcon.vue?vue&type=script&lang=js"
export * from "./IncompatipleIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0ae878",
  null
  
)

export default component.exports